import { useEffect } from 'react';
import { useSettings } from '@/contexts/SettingsContext';

export const useSettingsEffects = () => {
  const {
    compactMode,
    enableAnimations,
    enableHoverEffects,
    showTooltips,
  } = useSettings();

  useEffect(() => {
    // Apply compact mode
    const root = document.documentElement;
    
    if (compactMode) {
      root.classList.add('compact-mode');
    } else {
      root.classList.remove('compact-mode');
    }
  }, [compactMode]);

  useEffect(() => {
    // Apply animations
    const root = document.documentElement;
    
    if (enableAnimations) {
      root.classList.add('animations-enabled');
      root.classList.remove('animations-disabled');
    } else {
      root.classList.add('animations-disabled');
      root.classList.remove('animations-enabled');
    }
  }, [enableAnimations]);

  useEffect(() => {
    // Apply hover effects
    const root = document.documentElement;
    
    if (enableHoverEffects) {
      root.classList.add('hover-effects-enabled');
      root.classList.remove('hover-effects-disabled');
    } else {
      root.classList.add('hover-effects-disabled');
      root.classList.remove('hover-effects-enabled');
    }
  }, [enableHoverEffects]);

  useEffect(() => {
    // Apply tooltips
    const root = document.documentElement;
    
    if (showTooltips) {
      root.classList.add('tooltips-enabled');
      root.classList.remove('tooltips-disabled');
    } else {
      root.classList.add('tooltips-disabled');
      root.classList.remove('tooltips-enabled');
    }
  }, [showTooltips]);
}; 